/* Drop system: reveal on scroll (respects reduced motion) */
(function(){
  if (window.__dropInit) return; window.__dropInit = true;
  var els = function(){ return document.querySelectorAll('.drop .reveal:not(.in)'); };
  if (!('IntersectionObserver' in window)) { els().forEach(function(e){e.classList.add('in')}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
  }, {threshold:0, rootMargin:'0px 0px -8% 0px'});
  var arm = function(){ els().forEach(function(e){ io.observe(e); }); };
  if (document.readyState !== 'loading') arm(); else document.addEventListener('DOMContentLoaded', arm);
  document.addEventListener('shopify:section:load', arm);
  setTimeout(function(){ els().forEach(function(e){ e.classList.add('in'); }); }, 2000);
})();

/* Drop system: mobile nav toggle */
(function(){
  if (window.__dropNavInit) return; window.__dropNavInit = true;
  function closeNav(){
    var p = document.getElementById('DropMobileNav');
    var b = document.querySelector('.drop-header .nav-burger');
    if (p) p.hidden = true;
    if (b) b.setAttribute('aria-expanded','false');
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.drop-header .nav-burger');
    if (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
      return;
    }
    if (e.target.closest('.drop-header .nav-mobile a')) closeNav();
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') closeNav();
  });
})();
